const AUTH_CUSTOMER_MODULE_NAME = "auth-customer-module";
const SPORT_MODULE_NAME = "sport-module";
const NECCTON_NOTIFICATION_MODULE_NAME = "neccton-notification-module";
const FOOTER_MODULE_NAME = "footer-module-name";
const SEO_MODULE_NAME = "seo-module-name";
const RESPONSIBLE_GAMBLING_MODULE_NAME = "responsible-gambling";
const FORECAST_MODULE_NAME = "forecast-module";
const CASHIER_MODULE_NAME = "cashier-module";
export {
  AUTH_CUSTOMER_MODULE_NAME,
  CASHIER_MODULE_NAME,
  FOOTER_MODULE_NAME,
  FORECAST_MODULE_NAME,
  NECCTON_NOTIFICATION_MODULE_NAME,
  RESPONSIBLE_GAMBLING_MODULE_NAME,
  SEO_MODULE_NAME,
  SPORT_MODULE_NAME
};
